import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, styled, Typography } from "@mui/material";
import { OutlinedDropdownIconSVG } from "../../assets/customIcons";
import { MuiButton } from "./buttonComponent";
import { InputBox } from "./input";
import { MuiStack } from "./stackComponent";
var MuiSelect = styled(Select)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#DEE4EB'
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #AFD5FF",
            borderRadius: "8px",
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        '&.Mui-disabled': {
            backgroundColor: '#F4F7FA',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#DEE4EB'
            }
        },
        '& .MuiSvgIcon-root': {
            marginRight: '10px'
        }
    };
});
export var MuiSelectComponent = function (props) {
    var name = props.name, label = props.label, value = props.value, fullWidth = props.fullWidth, className = props.className, selectSx = props.selectSx, _a = props.error, error = _a === void 0 ? null : _a, labelSx = props.labelSx, onChange = props.onChange, _b = props.options, options = _b === void 0 ? [] : _b, width = props.width, variant = props.variant, valueExpr = props.valueExpr, _c = props.displayExpr, displayExpr = _c === void 0 ? "id" : _c, _d = props.addButton, addButton = _d === void 0 ? false : _d, _e = props.addSearchButton, addSearchButton = _e === void 0 ? false : _e, margin = props.margin, _f = props.size, size = _f === void 0 ? "small" : _f, caption = props.caption, _g = props.disabled, disabled = _g === void 0 ? false : _g, tabIndex = props.tabIndex, _h = props.isSelectDefaultDisabled, isSelectDefaultDisabled = _h === void 0 ? false : _h, _j = props.isMandatory, isMandatory = _j === void 0 ? false : _j, renderValue = props.renderValue, getOptionLabel = props.getOptionLabel // Custom function to format options
    ;
    var inputId = "".concat(name, "-input");
    return /*#__PURE__*/ React.createElement(FormControl, _extends({
        fullWidth: fullWidth,
        variant: variant,
        style: {
            width: width,
            margin: margin
        },
        className: className,
        size: size
    }, error && {
        error: true
    }), /*#__PURE__*/ React.createElement(InputLabel, {
        sx: labelSx,
        id: "".concat(inputId, "-label")
    }, label), /*#__PURE__*/ React.createElement(MuiSelect, {
        MenuProps: {
            disableScrollLock: true
        },
        IconComponent: OutlinedDropdownIconSVG,
        sx: _objectSpread(_objectSpread({}, selectSx), {}, {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #AFD5FF",
                borderRadius: "8px",
                boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            },
            color: !value ? '#999' : '#1B1D21',
            backgroundColor: 'white'
        }),
        fullWidth: fullWidth,
        id: inputId,
        labelId: "".concat(inputId, "-label"),
        name: name,
        value: value,
        onChange: onChange,
        displayEmpty: true,
        disabled: disabled,
        tabIndex: tabIndex,
        renderValue: function (selected) {
            var selectedOption = options.find(function (opt) { return opt[valueExpr] === selected; });
            return selectedOption ? getOptionLabel ? getOptionLabel(selectedOption) : selectedOption[displayExpr] : "Select ".concat(caption).concat(isMandatory ? ' *' : '');
        }
    }, addButton && /*#__PURE__*/ React.createElement(MenuItem, {
        value: ""
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "outlined",
        className: "change-data",
        onClick: props === null || props === void 0 ? void 0 : props.changeOptionsData,
        name: "+ Add Item"
    })), addSearchButton && /*#__PURE__*/ React.createElement(InputBox, {
        variant: "outlined",
        className: "Search",
        onChange: props === null || props === void 0 ? void 0 : props.Search,
        name: name
    }), /*#__PURE__*/ React.createElement(MenuItem, {
        value: "",
        id: "defaultSelect",
        disabled: isSelectDefaultDisabled
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, null, "Select ", caption), isMandatory && /*#__PURE__*/ React.createElement(Typography, null, "*"))), options === null || options === void 0 ? void 0 : options.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
        key: index,
        value: valueExpr ? item[valueExpr] : item === null || item === void 0 ? void 0 : item[displayExpr],
        style: {
            textWrap: "pretty",
            overflowX: "scroll"
        },
        id: "".concat(displayExpr, "-").concat(index)
    }, getOptionLabel ? getOptionLabel(item) : item[displayExpr]); })), error && /*#__PURE__*/ React.createElement(FormHelperText, {
        className: "errorMsg"
    }, error));
};
//Usecase
{ /* <MuiSelectComponent
 name="AttributeTypeId"
 displayExpr="Name"
 valueExpr="id"
 label={t("Attribute Type*")}
 required
 autoFocus
 fullWidth
 options={attributetype || []}
 onChange={handleInputChange}
 value={values?.AttributeTypeId}
 error={errors?.AttributeTypeId}
 /> */
}
